// note: must explicitly set t/f because of typescript

export default {
  // loadDummyData: true,
  loadDummyData: false,
}
